import { AbstractControl, ValidationErrors } from "@angular/forms";
import { DateTime } from "luxon";

export function formatDateTime(value: any) : any {
  if(!value) return value;
  
  let dateTime = DateTime.fromISO(value as string);
  if(!dateTime.isValid) {
    return value;
  }

  let stringValue = dateTime.toFormat('yyyy-MM-dd HH:mm'); 
  return stringValue;
}

export function DateValidator(control: AbstractControl): ValidationErrors | null {
  let value = control.value;
  if (!value) {
    return null;
  }

  if (typeof value === 'string' || value instanceof String) {
    let dateTime = DateTime.fromISO(value as string);
    if (dateTime.isValid) {
      return null;
    }
  }

  return { 'invalidDate': true };
}

export function todayOrLater(control: AbstractControl): ValidationErrors | null {
  let value = control.value;
  if (!value) {
    return null;
  }

  if (typeof value === 'string' || value instanceof String) {
    let dateTime = DateTime.fromISO(value as string);
    if (dateTime.isValid && dateTime.toMillis() >= DateTime.now().startOf('day').toMillis() ) {
      return null;
    }
  }

  return { 'todayOrLater': true };
}

function fromIsBeforeToValidator(from: string, to: string, errorKey: string): ValidationErrors | null {
  let fromDate = DateTime.fromISO(from);
  let toDate = DateTime.fromISO(to);
  if (toDate < fromDate) {
    return { [errorKey]: true };
  }

  return null;
}

export function DepartureValidator(control: AbstractControl): ValidationErrors | null {
  const { form } = control.value
  if (!form || !form.expectedArrivalDate || !form.expectedDepartureDate) {
    return null;
  }

  return fromIsBeforeToValidator(form.expectedArrivalDate, form.expectedDepartureDate, 'invalidDeparture');
}

export function PassportValidityValidator(control: AbstractControl): ValidationErrors | null {
  const { passport } = control.value
  if (!passport || !passport.issuedDate || !passport.expiryDate) {
    return null;
  }

  return fromIsBeforeToValidator(passport.issuedDate, passport.expiryDate, 'invalidIssuedExpiry');
}

export function SipsiValidityValidator(control: AbstractControl): ValidationErrors | null {
  const { sipsi } = control.value
  if (!sipsi || !sipsi.issuedDate || !sipsi.expiryDate) {
    return null;
  }

  return fromIsBeforeToValidator(sipsi.issuedDate, sipsi.expiryDate, 'invalidIssuedExpiry');
}

export function BusinessVisaValidityValidator(control: AbstractControl): ValidationErrors | null {
  const { businessVisa } = control.value
  if (!businessVisa || !businessVisa.issuedDate || !businessVisa.expiryDate) {
    return null;
  }

  return fromIsBeforeToValidator(businessVisa.issuedDate, businessVisa.expiryDate, 'invalidIssuedExpiry');
}

export function WorkVisaValidityValidator(control: AbstractControl): ValidationErrors | null {
  const { workVisa } = control.value
  if (!workVisa || !workVisa.issuedDate || !workVisa.expiryDate) {
    return null;
  }

  return fromIsBeforeToValidator(workVisa.issuedDate, workVisa.expiryDate, 'invalidIssuedExpiry');
}

export function WorkPermitValidityValidator(control: AbstractControl): ValidationErrors | null {
  const { workPermit } = control.value
  if (!workPermit || !workPermit.issuedDate || !workPermit.expiryDate) {
    return null;
  }

  return fromIsBeforeToValidator(workPermit.issuedDate, workPermit.expiryDate, 'invalidIssuedExpiry');
}